jQuery(document).ready(function($){

	$('.searchBtn').on('click', function(){
		$('.searchHldr').slideToggle();
	});

	var winWidth = $(window).width();
	$('.largePuffImg').each(function(){

		if(winWidth > 768){
			var siblingHeight = $(this).parent().siblings().height();
		} else {
			var siblingHeight = $(this).parent().siblings().height() / 2;
		}
		$(this).height(siblingHeight);
		$(this).parent().parent().parent().parent().find('.puffMap').height(siblingHeight);
		$(this).parent().height(siblingHeight);
	});

	// 2021-09-10 Removed for not working VC tab
	//$(function() {
	//	$('a[href*="#"]:not([href="#"])').click(function() {
	//		if(!$(this).parent().hasClass('vc_tta-panel-title')) {
	//			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
	//			var target = $(this.hash);
	//			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	//			if (target.length) {
	//				$('html, body').animate({
	//					scrollTop: target.offset().top - 30
	//				}, 1000);
	//				return false;
	//			}
//			}
//			}
//
//		});
//	});


	if(winWidth > 767) {
		var puffHeight = $('.startPuffContent').outerHeight();
		$('.startPuffImg').height(puffHeight / 2);
	}

	if(winWidth < 767){

		if(jQuery('.tb_submenu').length > 0){
			jQuery('body').addClass('hasSub');
		}
		var subMenu = $('.tb_submenu');
		var menuTitle = '';
		if(subMenu.data('mtitle')){
			var menuTitle = subMenu.data('mtitle');
		} else if(subMenu.data('title')){
			var menuTitle = subMenu.data('title');
		} else {
			var menuTitle = "Meny";
		}

		subMenu.addClass('mobileSubMenu');
		subMenu.prepend('<div class="sub-menuBtn">' + menuTitle + ' <i class="fa fa-plus" aria-hidden="true"></i></div>');
		subMenu.find('ul').hide();

		$('.sub-menuBtn').on('click', function(){
			subMenu.find('ul').slideToggle();
		});
	}

	// $('.multisite_blog').each(function(){
	// 	$('.innerContent').matchHeight();
	// });

	$('.multisite_blog').each(function(){
		$('.innerContent').matchHeight();
	});

	$('.tb_course_loop').each(function(){
		$('.single_blog_inner').matchHeight();
	});

	$('#blog_slide').each(function(){
		$('.blogContent').matchHeight();
	});

	$('.eqlhgt').each(function()  {
		$('.tb_puff-inner').matchHeight();
	});

	$('.rsBtn').on('click', function(){
		$('#readspeaker_button').addClass('readActive');
		$('#readspeaker_button a').trigger('click');
	});

	$('.searchBtn').on('click', function(){
		$('.searchWrp').toggleClass('searchActive');
	});

	$('.share').on('click', function(){
		$('.shareIconsWrp').find('.shareIcon').toggleClass('shareOpen');
	}); 

});


jQuery( window ).resize(function() {
	var winWidth = jQuery(window).width();
	jQuery('.largePuffImg').each(function(){

		if(winWidth > 768){
			var siblingHeight = jQuery(this).parent().siblings().height();
		} else {
			var siblingHeight = jQuery(this).parent().siblings().height() / 2;
		}
		jQuery(this).height(siblingHeight);
		jQuery(this).parent().parent().parent().parent().find('.puffMap').height(siblingHeight);
		jQuery(this).parent().height(siblingHeight);

	});

	if(winWidth > 767) {
		var puffHeight = jQuery('.startPuffContent').outerHeight();
		jQuery('.startPuffImg').height(puffHeight / 2);
	}


	if(winWidth < 767){
		if(jQuery('.tb_submenu').length > 0){
			jQuery('body').addClass('hasSub');
		}
		var menuTitle = '';
		if(jQuery('.tb_submenu').data('mtitle')){
			var menuTitle = jQuery('.tb_submenu').data('mtitle');
		} else if(jQuery('.tb_submenu').data('title')){
			var menuTitle = jQuery('.tb_submenu').data('title');
		} else {
			var menuTitle = "Meny";
		}
		if(!jQuery('.tb_submenu').hasClass('mobileSubMenu')) {
			jQuery('.tb_submenu').addClass('mobileSubMenu');
			jQuery('.tb_submenu').prepend('<div class="sub-menuBtn">'+menuTitle+' <i class="fa fa-plus" aria-hidden="true"></i></div>');
			jQuery('.tb_submenu').find('ul').hide();
			jQuery('.tb_submenu').find('.heading').hide();
			jQuery('.sub-menuBtn').on('click', function(){
				jQuery('.tb_submenu').find('ul').slideToggle();
			});
		}
	} else {
		jQuery('.tb_submenu').removeClass('mobileSubMenu');
		jQuery('.sub-menuBtn').remove();
		jQuery('.tb_submenu').find('ul').show();
		jQuery('.tb_submenu').find('.heading').show();
		jQuery('.tb_submenu').removeClass('mobileSubMenu');
		if(jQuery('.tb_submenu').length > 0){
			jQuery('body').removeClass('hasSub');
		}
	}
});
